import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.css']
})
export class ProgressCircleComponent {
  @Input() value: string = ''; 
  @Input() label: string = ''; 
  @Input() color: string = '#009FD3';


  get val() {
    const values = this.value.split('/');
    return Math.floor(Number(values[0])/Number(values[1]) * 100);
  }

  readonly circumference = 2 * Math.PI * 45;
}